import {FC, useMemo} from 'react'
import {ID} from '../../../../../_metronic/helpers'
import {useKTable} from '../../../contexts/KTableProvider'
type Props = {
  id: ID
  clickHandler?: (id: ID) => void // Define la propiedad onClick
  disable?: boolean
}

const KTableSelectionCell: FC<Props> = ({id, clickHandler, disable}) => {
  const {selected, onSelect} = useKTable()
  const isSelected = useMemo(() => selected.includes(id), [id, selected])

  const handleChangeSelect = (id: any) => {
    console.log('select => ', id)
    onSelect(id)
    if (clickHandler) {
      clickHandler(id)
    }
  }
  return (
    <>
      <div className='form-check form-check-custom form-check-solid ps-2'>
        <input
          className='form-check-input border border-gray-500'
          type='checkbox'
          data-kt-check={isSelected}
          data-kt-check-target='#kt_table_users .form-check-input'
          checked={isSelected}
          onChange={() => handleChangeSelect(id)}
          disabled={disable}
        />
      </div>
    </>
  )
}

export {KTableSelectionCell}
